import React from "react";

export const SurveyStats = (props) => {
  const { total } = props;
  return (
    <div>
      <div className="row px-4">
        <div className="col-md-12 d-flex justify-content-center">
          <span className="py-2 font-survey-response">
            {" "}
            Total Surveys Responses: {total}
          </span>
        </div>
      </div>
    </div>
  );
};
